// extracted by mini-css-extract-plugin
export var embeddedIcon = "style-module--embedded-icon--33a3e";
export var inline = "style-module--inline--a3e24";